<template>
  <div class="cb-body__wrap">
    <div class="cb-body__content">
      <div class="cb-section">
        <div class="cb-options" :class="{'cb-options--active': payment_method == selected_payment_method}" v-for="(payment_method, index) in payment_method_list" :key='index' v-cb-link = "'shadow'" @click="setPaymentMethod(payment_method)">
          <div class="cb-options__group">
            <div class="cb-options__left">
              <div class="cb-options__radio" :style="payment_method == selected_payment_method && backgroundColor">
                <i class="icon-check cb-options__icon" aria-hidden="true"></i>
              </div>
            </div>
            <div class="cb-options__right">
              <payment-method-summary :persistent-payment-method='payment_method' :transient-payment-method='payment_method.transient && payment_method'></payment-method-summary>
            </div>
          </div>
        </div>
      </div>
      <div class="cb-section">
        <cb-button @next="navigate('payment_method')" :custom-class="'secondary'" v-if="canAdd" :attr="'add_payment_action'">
          {{t('payment_method.choose.add')}}
        </cb-button>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import PaymentMethodSummary from "@/components/modules/hosted-pages/PaymentMethodSummary"
import ButtonField from "@/components/collections/form/ButtonComponent"
export default {
  mounted() {
    },
    methods: {
      navigate(name) {
        this.$router.push({
          name: name,
          query: {
            mode: "empty"
          }
        });
      },
      setPaymentMethod(payment_method) {
        if(payment_method.transient || this.selected_payment_method.id != payment_method.id) {
          this.$store.dispatch('set_payment_method_to_order', payment_method);
          this.$store.dispatch('attach_pm_subscription_level', true);
        }
        window.cbTimeout(() => {
          this.$router.push({name: 'review'});
        }, 300);
      }
    },
    computed: {
      ...mapGetters([
        'payment_method_list',
        'selected_payment_method'
      ]),
      canAdd() {
        return this.$store.state.config.pm_count == -1 || (this.$store.getters.payment_method_list.length < this.$store.state.config.pm_count);
      }
    },
    components: {
      'payment-method-summary': PaymentMethodSummary,
      "cb-button": ButtonField
    }
}
</script>



// WEBPACK FOOTER //
// ChoosePaymentMethod.vue?65442386